// extracted by mini-css-extract-plugin
export default {"textAreaResponse":"_iOqIWa8o5g3_1gW6uzC"};